import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageTitle from '../../layouts/PageTitle';
import { exportCOIReport } from '../../../services/FormService';
import { useLoader } from '../../../context/LoaderCotext';
import moment from 'moment';

const COIReport = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const { showLoader, hideLoader } = useLoader();

  const handleExport = async (e) => {
    e.preventDefault();
    showLoader();
    try {
      const response = await exportCOIReport(year);
      if (response) {
        // Create a blob link to download
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        const fileName = `COI_Submission_Report_${year}_${moment().valueOf()}.xlsx`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        toast.success('Report generated successfully!');
      } else {
        toast.error('Failed to generate report.');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to export report.');
    } finally {
      hideLoader();
    }
  };

  return (
    <>
      <PageTitle activeMenu="COI Submission Report" motherMenu="Reports" />
      <div className="row">
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>Export COI Submission Report</Card.Title>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleExport}>
                <Row className="align-items-end">
                  <Col md={4}>
                    <Form.Group controlId="year">
                      <Form.Label>Select Year</Form.Label>
                      <Form.Control
                        type="number"
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                        min="2000"
                        max="2100"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Button variant="primary" type="submit">
                      Export to Excel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </div>
      <ToastContainer />
    </>
  );
};

export default COIReport;
